import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { captureException, startSentry } from './app/core/services/sentry-client';

registerLocaleData(localeFr);

// Sentry is fetched as its own chunk rather than imported here, so ~271 kB of
// SDK stays off the critical path. Kicked off without awaiting: bootstrap must
// not wait on error reporting. Anything raised in the meantime is buffered by
// the client and flushed once the SDK lands.
void startSentry();

bootstrapApplication(App, appConfig).catch((err: unknown) => captureException(err));
